import EventScorekeepingDelete from '@/screens/EventScorekeepingDelete';

export default function PrivateEventEventIdScorekeepingDeleteIndexRoute() {
  return <EventScorekeepingDelete />;
}
